module.exports = __webpack_public_path__ + "img/BannerClientesDesktop.9e7736f8.png";